import React from 'react';

interface GradientBackgroundProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * A reusable background component with a customizable gradient.
 * Usage: Wrap your content with <GradientBackground>...</GradientBackground>
 */
const GradientBackground: React.FC<GradientBackgroundProps> = ({
  children,
  className = '',
  style = {},
}) => {
  return (
    <div
      className={`min-h-screen w-full flex flex-col overflow-hidden bg-[linear-gradient(180deg,var(--gradient-primary)_50%,var(--gradient-secondary)_100%)] ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default GradientBackground;
